export type RentVK = 1 | 2 | 3 | 4
export type RentCoverage = 1 | 2 | 3 | 4 | 5

export type RentAttributeBase = {
  balcony: number
  terrace: number
  equipment: number
  garage: number
  elevator: number
}

export type RentAttributeNewBuild = RentAttributeBase & {
  otherMaterial: number // jiný konstrukční materiál než panel a cihla
}

export const COVERAGE_INTENSITY: Record<RentCoverage, string> = {
  1: '0-30',
  2: '31-60',
  3: '61-90',
  4: '90-150',
  5: '150+',
}

export const rentAttributePriceByVK: Record<RentVK, RentAttributeBase> = {
  1: {
    balcony: 11,
    terrace: 32,
    equipment: 33,
    garage: 48,
    elevator: 36,
  },
  2: {
    balcony: 3,
    terrace: 32,
    equipment: 33,
    garage: 43,
    elevator: 40,
  },
  3: {
    balcony: 3,
    terrace: 32,
    equipment: 28,
    garage: 34,
    elevator: 44,
  },
  4: {
    balcony: 10,
    terrace: 32,
    equipment: 31,
    garage: 36,
    elevator: 67,
  },
}

export const rentAttributePriceByVKNewBuild: Record<
  RentVK,
  RentAttributeNewBuild
> = {
  1: {
    balcony: 10,
    terrace: 21,
    equipment: 22,
    garage: 31,
    elevator: 20,
    otherMaterial: 30,
  },
  2: {
    balcony: 8,
    terrace: 16,
    equipment: 19,
    garage: 29,
    elevator: 14,
    otherMaterial: 32,
  },
  3: {
    balcony: 7,
    terrace: 21,
    equipment: 18,
    garage: 30,
    elevator: 14,
    otherMaterial: 38,
  },
  4: {
    balcony: 8,
    terrace: 24,
    equipment: 18,
    garage: 31,
    elevator: 19,
    otherMaterial: 51,
  },
}

export const rentVKByAreaThresholds: Array<{
  maxArea: number
  vk: RentVK
  text: string
}> = [
  { maxArea: 45, vk: 1, text: 'do 45' },
  { maxArea: 62, vk: 2, text: '45 - 62' },
  { maxArea: 78, vk: 3, text: '62 - 78' },
  { maxArea: 120, vk: 4, text: 'nad 78' },
  // MFCR statistical data assumes a maximum of 120 m²,
  // but for internal purposes we also classify larger units as VK4.
]

export const getVKByUnitArea = (area: number): RentVK => {
  for (const vk of rentVKByAreaThresholds) {
    if (area < vk.maxArea) return vk.vk
  }
  return 4
}
